var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['my-menu', _vm.mode === 'horizontal' ? 'horizontal' : 'vertical']},_vm._l((_vm.routeList),function(item){return _c('div',{key:item.name,class:item.name == _vm.activedRoute ? 'actived' : '',on:{"click":function($event){return _vm.switchPage(item.name)}}},[_vm._v("\n\t\t"+_vm._s(item.text)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }